import React from "react";
import { LoginGigyaInterface } from "../shared/interfaces/LoginGigyaInterface";

interface GlobalContextInterface {
    fontSize?: { get: number; set: (size: number) => void };
    superFooter?: { get: boolean; set: (value: boolean) => void };
    gigyaContext: LoginGigyaInterface;
    searchWordContent: string;
    setSearchWordContent: (str) => void;
    city?: {get: boolean, set: (city: boolean) => void};
    showModalNewLeader?: { get: boolean; set: (show: boolean) => void };
    showModalEditLeader?: { get: boolean; set: (show: boolean) => void };
}

const context: GlobalContextInterface = {
    gigyaContext: {
        login: () => null,
        loginComfamaId: () => null,
        logout: () => null,
        updateProfile: () => null,
        register: () => null,
        showScreen: () => null,
        updateProfilePhoto: () => null,
    },
    searchWordContent: "",
    setSearchWordContent: () => null,
};

const GlobalContext = React.createContext(context);

export default GlobalContext;
